import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { shallowRef, ref } from 'vue';
import { useSettingsStore } from '@/api/store/settings';
import { appService } from '@/api/services/app';
import router from '@/router';
import SearchFilter from "@/components/custom/SearchFilter.vue";
import ButtonFilterSelect from "@/components/custom/ButtonFilterSelect/ButtonFilterSelect.vue";
import HomeBranding from '@/views/HomeComponents/HomeBranding.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomePreview',
  setup(__props) {

const settingsStore = useSettingsStore();

let loaded = false;
let error = false;

const sortTabSelectedValue = shallowRef({
  name: 'Sort',
  label: 'Sort'
})
const filterTabSelectedValue = shallowRef({
  name: 'Filter',
  label: 'Filter'
})

let image = ref<string | null>(null);

const uuid = router.currentRoute.value.params.uuid as string;

if(!uuid) {
  error = true;
}

appService.fetchDisplayById(uuid).then((response: any) => {
  settingsStore.settings = JSON.parse(response.settings);
  image.value = response.image?.file?.file_path;
  console.log(image);
  loaded = true;
}).catch((err: any) => {
  console.log(err);
});



return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_unref(error))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "text-center" }, [
          _createElementVNode("h3", null, "Unable to load preview")
        ], -1)
      ]))]))
    : (!_unref(loaded))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_linear, {
            indeterminate: "",
            color: "primary"
          }),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-center" }, [
            _createElementVNode("h3", null, "Loading Preview...")
          ], -1))
        ]))
      : (_openBlock(), _createBlock(_component_v_container, {
          key: 2,
          class: "py-4 px-6"
        }, {
          default: _withCtx(() => [
            _createVNode(HomeBranding, { image: _unref(image) }, null, 8, ["image"]),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "px-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { class: "text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      icon: "",
                      color: _unref(settingsStore).settings.primaryColor,
                      variant: "flat",
                      size: "x-large",
                      class: "sw-button-roundness"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          icon: "fa-heartbeat",
                          color: "white",
                          size: "30"
                        })
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "smText" }, "Menu 1", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { class: "text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      icon: "",
                      color: _unref(settingsStore).settings.primaryColor,
                      variant: "flat",
                      size: "x-large",
                      class: "sw-button-roundness"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          icon: "fa-shopping-cart",
                          color: "white",
                          size: "30"
                        })
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "smText" }, "Menu 2", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { class: "text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      icon: "",
                      color: _unref(settingsStore).settings.primaryColor,
                      variant: "flat",
                      size: "x-large",
                      class: "sw-button-roundness"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          icon: "fa-folder-open",
                          color: "white",
                          size: "30"
                        })
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "smText" }, "Menu 3", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { class: "text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      icon: "",
                      color: _unref(settingsStore).settings.primaryColor,
                      variant: "flat",
                      size: "x-large",
                      class: "sw-button-roundness"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          icon: "fa-list",
                          color: "white",
                          size: "30"
                        })
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "smText" }, "Menu 4", -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "p-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("h3", null, "App Preview ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("p", null, "This is an app preview, for a full view please login as your demo client to view the full portal", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "text-center py-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: _unref(settingsStore).settings.buttonColor
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode(" Example Button 1 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: _unref(settingsStore).settings.buttonColor
                    }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode(" Example Button 2 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "text-center py-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(SearchFilter)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  class: "d-flex px-3",
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "mt-1 position-relative left-filter-text" }, {
                      default: _withCtx(() => [
                        _createVNode(ButtonFilterSelect, {
                          modelValue: sortTabSelectedValue.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sortTabSelectedValue).value = $event)),
                          isTabSelected: true,
                          text: "Sort",
                          multiple: false,
                          icon: "sort-icon",
                          items: ['Sort 1', 'Sort 2', 'Sort 3'],
                          "single-line": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { class: "mt-1 position-relative left-filter-text" }, {
                      default: _withCtx(() => [
                        _createVNode(ButtonFilterSelect, {
                          modelValue: filterTabSelectedValue.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterTabSelectedValue).value = $event)),
                          isTabSelected: true,
                          multiple: false,
                          text: "Filter",
                          items: ['Filter 1', 'Filter 2', 'Filter 3'],
                          "single-line": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
}
}

})